import React from "react";
import { ImageSourceSetData } from "./classes/ImageSourceSet";
import {
  getLargestImage,
  getDefaultImage,
  timestampToTime,
  sendEventTracking,
} from "../utils/GeneralUtils";
import styles from "./RecommendContent.module.scss";
import SonicLink from "./routing/SonicLink";

type Props = {
  id: string;
  name: string;
  start_date: number;
  type: string;
  trackingLabel: string;
  imgs?: Array<ImageSourceSetData>;
};

const RecommendContent: React.FC<Props> = ({
  id,
  name,
  start_date,
  type,
  trackingLabel,
  imgs,
}) => {
  return (
    <SonicLink
      to={`/${type}/${id}`}
      className={styles["c-recommendContent"]}
      onClick={() =>
        sendEventTracking("click", "EventRecommend", trackingLabel)
      }
    >
      <div className={styles["c-recommendContent__img"]}>
        <img
          src={imgs && imgs[0] ? getLargestImage(imgs[0]) : getDefaultImage()}
        />
      </div>
      <div className={styles["c-recommendContent__info"]}>
        <div className={styles["c-recommendContent__info-box"]}>
          <p className={styles["c-recommendContent__info-box__date"]}>
            {timestampToTime(start_date, false)}
          </p>
          <span></span>
          <p className={styles["c-recommendContent__info-box__type"]}>
            {type.toLocaleUpperCase()}
          </p>
        </div>
        <p>{name}</p>
      </div>
    </SonicLink>
  );
};

export default RecommendContent;
